import { render, staticRenderFns } from "./CreateQuotes.vue?vue&type=template&id=f5452d92&lang=pug&"
import script from "./CreateQuotes.vue?vue&type=script&lang=js&"
export * from "./CreateQuotes.vue?vue&type=script&lang=js&"
import style0 from "./CreateQuotes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports